import $ from 'jquery'
import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'
import { TimelineMax, TweenMax, Elastic, Expo, Sine, Back } from 'gsap'
import { updateNav, destroyNavUpdateCallback, setCollectionPrevTrigger, setCollectionNextTrigger, setOpenObjectCallback, destroyOpenObjectCallback, setCurrentIndex, setCollectionTotal, setItems } from './../shared/collection-nav'
import { updateObjectMedia } from './../shared/object-media'

import Controller from "./Controller.js";
// import mainController from './../MainController';

class CollectionObjectsController extends Controller {
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    this.initInfiniteList()
    this.updateNavItems()
  }
  /**
  * Add event listeners called on <code>onViewShow()</code>
  **/
  addEventListeners() {
    super.addEventListeners();
    this.locationPath = window.location.pathname;
    $("body").on("click", ".object-loader", $.proxy(this.onObjectLinkClick, this))
    $("body").on("click", ".object-trigger", $.proxy(this.onObjectTriggerClick, this))
  }
  /**
  * Remove event listeners called on <code>onViewHide()</code>
  **/
  removeEventListeners() {
    super.removeEventListeners();
    this.removeInfiniteListeners()
    this.removeObjectListeners()
    $("body").off("click", ".object-loader", $.proxy(this.onObjectLinkClick, this))
    $("body").off("click", ".object-trigger", $.proxy(this.onObjectTriggerClick, this))
    document.documentElement.classList.remove("infinite-list-loading")
    document.documentElement.classList.remove("object-view-open")
    // destroy collection nav promisse
    this.destroyCollectionNav()
  }

  /**
   * Object trigger (carousel NAV link click)
   */
   onObjectTriggerClick(e) {
    if (!e.metaKey & !e.ctrlKey) {
      e.preventDefault()
      const href = e.currentTarget.getAttribute("href")
      const objLink = document.querySelector(".object-loader[href='" + href +"']")
      if (objLink) {
        document.documentElement.classList.add("object-nav-transition")
        this.openToObject(objLink)
      }
    }
   }

  /**
   * ### Async AJAX requests
   */
  onObjectLinkClick(e) {
    if (!e.metaKey & !e.ctrlKey) {
      e.preventDefault()
      this.removeObjectListeners()
      document.documentElement.classList.add("fw-object-loading")
      // set collection nav promisse
      const a = e.currentTarget
      this.updateObjectSiblingsNav(a)
      this.updateObjectIndex(a)
      const path = a.dataset.url
      if (window.history) {
        // history push state
        const url = a.getAttribute("href")
        window.history.pushState(null, null, url);
      }
      $.get(path, {}, this.onObjectLoaded.bind(this))
    }
  }

  openToObject(link) {
    // Hide and open...
    this.objectHide(() => {
      link.click()
    })
  }


  // ### update OBJECT prev / next nav
  updateObjectSiblingsNav(a) {
    setOpenObjectCallback(this.openToObject.bind(this))
    const prev = this.getObjectLinkPrev(a)
    setCollectionPrevTrigger(prev)
    this.loadObjectLinkNext(a, updateNav)
  }
  // ### update object index (eg. 5/17)
  updateObjectIndex(a) {
    const ind = this.getObjectLinkIndex(a)
    const total = this.getObjectLinkIndexTotal(a)
    // trace("update object index:",ind, "total:", total)
    setCurrentIndex(ind)
    setCollectionTotal(total)
  }
  // ### zwraca numer, który w kolejce jest
  getObjectLinkIndex(a) {
    let ind = 0
    const href = a.getAttribute("href")
    const wrapper = a.closest(".infinite-list")
    const list = wrapper ? [...wrapper.querySelectorAll(".object-loader")] : []
    list.forEach((el, index) => {
      if (el.getAttribute("href") == href) {
        ind = index + 1
        return ind
      }
    })
    return ind
  }
  // ### zwraca całkowitą liczbę obiektów na liście
  getObjectLinkIndexTotal(a) {
    const wrapper = a.closest(".infinite-list")
    const dataTotal = wrapper ? wrapper.dataset.total : null
    return dataTotal ? parseInt(dataTotal) : 0
  }
  // search for prev object link
  getObjectLinkPrev(a) {
    let trigger
    const colDiv = a.parentNode
    const prevCol = colDiv.previousSibling
    if (prevCol && prevCol.nodeType === Node.ELEMENT_NODE) {
      trigger = prevCol.querySelector(".object-loader")
    }
    return trigger
  }
  // search for next object link
  loadObjectLinkNext(a, callback = null) {
    let trigger    
    let colDiv = a.parentNode
    let nextCol = colDiv.nextSibling
    if (nextCol && nextCol.nodeType === Node.ELEMENT_NODE) {
      trigger = nextCol.querySelector(".object-loader")
      setCollectionNextTrigger(trigger)
      // send update callback to ObjectController
      if (callback) {
        callback()
      }
    } else {
      setCollectionNextTrigger(null)
      // set ID of last column
      const randomId = "c-" + Math.round(Math.random() * 99999999)
      colDiv.id = randomId
      // check infinity scroll state.. load next page and thten update
      this.checkAndLoadObjects(() => {
        // workaround (colDiv is lost after load...)
        colDiv = document.getElementById(randomId) 
        const $nextCol = $(colDiv).next()
        if ($nextCol.length > 0) {
          nextCol = $nextCol.get(0)
          trigger = nextCol.querySelector(".object-loader")
          setCollectionNextTrigger(trigger)
          if (callback) {
            callback()
          }
        }
      })
    }
    
  }

  destroyCollectionNav() {
    destroyNavUpdateCallback()
    destroyOpenObjectCallback()
    setCollectionPrevTrigger(null)
    setCollectionNextTrigger(null)
  }

  onObjectLoaded(response) {
    if (!this.active || !response) {
      document.documentElement.classList.remove("fw-object-loading")
      return
    }
    document.documentElement.classList.remove("fw-object-loading")
    document.documentElement.classList.add("object-view-open")
    const stage = document.querySelector("#stage")
    const $response = $(response)
    $(stage).append($response)
    this.initObject($response)
    this.objectShow()
  }
  initObject($response) {
    this.addObjectListeners()
    const close = document.querySelector(".object-close")
    if (close) {
      close.classList.add("no-as")
      close.href = "#"
    }
    // ASwap init controllers
    if ($response && $response.length) {
      let controllers = [];
      const container = $response.get(0);
      if (container) {
        controllers = RytmWebflow.aswap.getControllersFromContainer(container)
      }
      controllers.forEach((c) => {
        c.onViewSwapComplete(null)
        c.onViewShow(null)
        c.onViewShown(null)
      })
    }
  }
  addObjectListeners() {
    $("body").on("click", ".object-close", $.proxy(this.onObjectClose, this))
  }
  removeObjectListeners() {
    $("body").off("click", ".object-close", $.proxy(this.onObjectClose, this))
  }

  onObjectClose(e) {
    e.preventDefault()
    this.removeObjectListeners()
    this.objectHide()
    // destroy nav callback
    destroyNavUpdateCallback(null)
  }
  objectShow() {
    updateObjectMedia()
    const media = document.querySelector(".object-media")
    const navCarousel = document.querySelector(".object-full .r-owl-carousel")
    const data = document.querySelector(".object-data")
    if (media && data) {
      const vW = window.innerWidth
      const vH = window.innerHeight
      TweenMax.from(media, .35, {alpha: 0, ease: Sine.easeOut})
      TweenMax.from(navCarousel, .35, {alpha: 0, ease: Sine.easeOut})
      TweenMax.from(data, .6, {x: vW * .5, ease: Expo.easeOut})
    }
  }
  objectHide(callback = null) {
    const media = document.querySelector(".object-media")
    const navCarousel = document.querySelector(".object-full .r-owl-carousel")
    const data = document.querySelector(".object-data")
    if (media && data) {
      const vW = window.innerWidth
      const vH = window.innerHeight
      TweenMax.to(media, .3, {alpha: 0, ease: Sine.easeIn})
      TweenMax.to(navCarousel, .3, {alpha: 0, ease: Sine.easeIn})
      TweenMax.to(data, .6, {x: vW * .5, ease: Expo.easeIn, onComplete: () => {
        this.objectHideComplete(callback)
      }})
    } else {
      this.objectHideComplete(callback)
    }
  }
  objectHideComplete(callback = null) {
    const wrapper = document.querySelector(".async-fw-object")
    if (wrapper) {
      wrapper.remove()
    }
    document.documentElement.classList.remove("object-view-open")
    if (window.history && this.locationPath) {
      window.history.pushState(null, null, this.locationPath);
    }
    if (callback) {
      callback()
    }
  }


  /**
   * ### infinite list ###
   */
  getListWrapper() {
    return document.querySelector(".infinite-list")
  }
  // add infinite listeners
  addInfiniteListeners() {
    $(window).on("scroll", $.proxy(this.onWindowScroll, this))
  }
  // remove infinite listeners
  removeInfiniteListeners() {
    $(window).off("scroll", $.proxy(this.onWindowScroll, this))
  }
  onWindowScroll(e) {
    this.checkFooterState()
    if (!this.isAwaitingRequest) {
      if (this.testBottom(500)) {
        this.checkAndLoadObjects()
      }
    }
  }
  checkFooterState() {
    const minY = 300
    const offsetBottom = 800
    clearTimeout(this.footerStateTimeout)
    if (window.innerWidth >= 768) {
      if (($(window).scrollTop() > minY && !this.testBottom(offsetBottom)) || this.isAwaitingRequest) {
        document.documentElement.classList.add("footer-infinite-scroll")
      } else {
        this.footerStateTimeout = setTimeout(() => {
          document.documentElement.classList.remove("footer-infinite-scroll")
        }, 300)
        
      }
    } else {
      document.documentElement.classList.remove("footer-infinite-scroll")
    }
  }
  checkAndLoadObjects(callback = null) {
    const nextPath = this.getNextPagePath()
    if (nextPath) {
      this.requestPage(nextPath, callback)
    }
  }
  testBottom(offset = 0) {
    return $(window).scrollTop() + $(window).height() > $(document).height() - offset
  }

  initInfiniteList() {
    this.isAwaitingRequest = false;
    this.checkFooterState()
    const nextPath = this.getNextPagePath()
    if (nextPath) {
      this.addInfiniteListeners()
      // initial first AJAX request call 
      this.requestPage(nextPath)
    }
  }
  getNextPagePath() {
    let path
    const list = this.getListWrapper()
    if (list) {
      const url = list.dataset.url
      const nextPath = list.dataset.nextPath
      if (url && nextPath && nextPath != "undefined" && nextPath != "null") {
        path = url + nextPath
      }
    }
    return path
  }
  requestPage(path, callback = null) {
    if (!this.isAwaitingRequest) {
      document.documentElement.classList.add("infinite-list-loading")
      this.isAwaitingRequest = true
      $.get(path, {}, (response) => {
        this.onRequestPageComplete(response, callback)
      })
    }
  }
  onRequestPageComplete(response, callback = null) {
    if (!this.active || !response) {
      document.documentElement.classList.remove("infinite-list-loading")
      this.isAwaitingRequest = false
      return
    }
    const paging = response.paging
    const next = response.next
    // trace(paging)
    const list = this.getListWrapper()
    list.dataset.nextPath = next ? next : null
    if (response.html) {
      list.innerHTML += response.html
    }
    this.isAwaitingRequest = false
    // update object nav carousel items
    this.updateNavItems()
    document.documentElement.classList.remove("infinite-list-loading")
    if (callback) {
      callback()
    }
  }

  /**
   * Object nav carousel items
   */
  updateNavItems() {
    const container = document.querySelector(this.getContainerSelector())
    const list = [...container.querySelectorAll('.object-list')]
    setItems(list);
  }


}
export default CollectionObjectsController